import React, { useState, useEffect, useContext } from 'react';

import { IComponentPay } from '../../component.d';
import { ThemeContext } from '../../store/ThemeProvider';
import ReactSVG from 'react-svg';

import { inject, observer } from 'mobx-react';

const Index = (props: IComponentPay) => {
  const { type, field, goods_id, onChange, formData } = props;
  const { pagedataStore, wxuserStore, uiStore } = props.rootStore!;
  const [loading, setLoading] = useState(false);

  const { mainColor, componentColor, h1Color, h2Color } = useContext(
    ThemeContext
  );
  const [good, setGood] = useState({} as any);
  const [charge, setCharge] = useState(null as any);

  useEffect(() => {
    if (goods_id) {
      pagedataStore.getPayGood(goods_id).then((res: any) => {
        setGood(res);
      });
    }
  }, [goods_id]);

  const checkResult = () => {
    // setPass(true);
    return pagedataStore.getCharge(goods_id).then((res: any) => {
      if (res && res.code == '200') {
        setCharge(res.data);
      }

      return res.data;
    });
  };

  useEffect(() => {
    if (charge && Number(charge.status) == 1) {
      onChange(type, field, goods_id);
    }
  }, [charge]);

  useEffect(() => {
    if (good && good.id) {
      checkResult();
    }
  }, [good]);

  const makePreCharge = () => {
    if (wxuserStore.user.is_mock) {
      wxuserStore.auth();
      return;
    }

    // 检查一下当前手机号是否已经验证通过
    if (formData) {
      let flag = false;
      Object.keys(formData).forEach((key: string) => {
        let item = formData[key];
        if (item) {
          if (item.type == 'form_phone') {
            if (item.value && item.value.phone && item.value.code) {
              flag = true;
            }
          }
        }
      });

      if (!flag) {
        uiStore.showToast({
          content: '请先验证手机号'
        });
        return;
      }
    }

    if (good) {
      const afterPay = (res: any) => {
        if (res && res == 'success') {
          uiStore.showToast({
            content: '付费成功'
          });
          checkResult();
        } else if (res && res == 'check') {
          checkResult();
        } else {
          uiStore.showToast({
            content: '付费失败'
          });
        }
      };

      if (charge && charge.id && Number(charge.status) == 0) {
        pagedataStore
          .makePayUseCharge(good.id, window.pageDetail.link_id, charge.id, true)
          .then(afterPay);
      } else {
        pagedataStore
          .makePrePay(good.id, window.pageDetail.link_id, true)
          .then(afterPay);
      }
    }
  };

  return (
    <div className="all-for-pay">
      <div className="pay-content weui-cells__group weui-cells__group_form">
        <div className="pay-tooltip weui-cell">
          <ReactSVG
            src={require('../../svg/question-circle.svg')}
            style={{ marginRight: 5, width: 16, height: 16 }}
          />
          所填写的手机号为付费成功后进入页面的凭证
        </div>
        <div className="pay-price weui-cell">
          ￥{(Number(good.price || 0) / 100).toFixed(2)}
        </div>
        {charge && Number(charge.status) == 1 ? (
          <>
            <div className="pay-check weui-cell">已支付成功</div>
          </>
        ) : (
          <>
            <div className="pay-button weui-cell">
              <div
                className="weui-btn weui-btn_primary"
                onClick={makePreCharge}
              >
                立即支付
              </div>
            </div>
            <div className="pay-check weui-cell">
              <a
                onClick={() => {
                  if (loading) {
                    return;
                  }
                  setLoading(true);
                  checkResult().then((res: any) => {
                    setLoading(false);
                    if (res) {
                      if (res.status == 0) {
                        uiStore.showToast({
                          content: '付费失败，请重新支付'
                        });
                      }
                    } else {
                      uiStore.showToast({
                        content: '未查询到付费记录'
                      });
                    }
                  });
                }}
              >
                已支付，点击验证
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default inject('rootStore')(observer(Index));
